import { useLogout } from '@alice-financial/alice-sdk'

/**
 * A zero-render logout page that clears local state and returns the user to the
 * root of the application (which will typically redirect to Login)
 */
export const Logout = () => {
  useLogout()
  return null
}
